<script lang="ts">
  import type { TextField } from "@customTypes/statamicFields";
  import type { StatamicAsset } from "@customTypes/statamic";
  import Blocks from "@components/blocks/Blocks.svelte";
  import ContentCard from "@components/content/ContentCard.svelte";
  import { convertStatamicAssetToCDN } from "@utils/cdn";

  /**
   * Props
   */
  export let preview_video_url: TextField;
  export let preview_video_image_url: StatamicAsset;
  export let blocks: any;
</script>

<ContentCard
  variant="videoPlayer"
  backgroundImageUrl={convertStatamicAssetToCDN(preview_video_image_url.id)}
  backgroundVideoUrl={preview_video_url || ""}
>
  <Blocks {blocks} />
</ContentCard>
